var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30975 22C1.53246 22 0.424541 20.0362 1.31319 18.4721L10.0034 3.17301C10.8921 1.609 13.1079 1.609 13.9966 3.17301L22.6868 18.4721C23.5755 20.0362 22.4675 22 20.6903 22H3.30975ZM20.6901 19.6483L11.9998 4.34912L3.30957 19.6483H20.6901Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 7C12.4229 7 12.8333 7.41041 12.8333 7.91667V13.4167C12.8333 13.9229 12.4229 14.3333 11.9167 14.3333C11.4104 14.3333 11 13.9229 11 13.4167V7.91667C11 7.41041 11.4104 7 11.9167 7Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 16.1667C11.4104 16.1667 11 16.5771 11 17.0833C11 17.5896 11.4104 18 11.9167 18C12.4229 18 12.8333 17.5896 12.8333 17.0833C12.8333 16.5771 12.4229 16.1667 11.9167 16.1667Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2bbeeb1ffeb672ba9db8da058235cb9f.svg";
export { ForwardRef as ReactComponent };